import { useBreadcrumbTitle } from 'sharedUi/BreadcrumbContext';
import { PageSkeleton } from '../../components/common/panel';
import { useSecureNavigation } from '../../hooks/useSecureNavigation';
import EvalRunResult from '../../components/ai-runs/eval-run-result';

const EvalRunView = () => {
  const { id, isReady, navigateToList } = useSecureNavigation({
    entity: 'eval-run',
    basePath: '/eval-runs',
  });

  useBreadcrumbTitle('Eval Run');

  if (!isReady || !id) return <PageSkeleton panels={1} />;

  return (
    <div className="p-4" data-testid="SCR-EvalRun-View">
      <EvalRunResult runRef={id} title="Eval Run" onBack={() => navigateToList()} />
    </div>
  );
};

export default EvalRunView;
